/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  requestCreateScheduledEbilling,
  requestGetScheduledEbilling,
  requestListKap,
  requestListScheduledEbilling,
  requestUpdateScheduledEbilling,
  resetScheduledEbilling,
  useAuthState,
  useEbillingDispatch,
  useEbillingState,
} from "../../Context";
import FormLabel from "../../Components/FormLabel";
import { NumericFormat, PatternFormat } from "react-number-format";
import ReactDatePicker from "react-datepicker";
import { Button } from "../../Components/Button";
import { ModalConfirm } from "../../Components/ModalConfirm";
import { useNavigate, useParams } from "react-router-dom";
import {
  periodOptions,
  billingPeriods,
  ebillingYearOptions,
} from "../../Constants";
import { getErrorMessages } from "../../Utils";
import { Alert } from "../../Components/Alert";
import Badge from "../../Components/Badge";

const months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

const STATUS = [
  { label: "Active", value: "ACTIVE" },
  { label: "paused", value: "PAUSED" },
];

const membershipType = {
  PREMIUM: "success",
  CONSULTANT: "info",
};

const EbillingScheduleCreate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const dispatch = useEbillingDispatch();
  const { user } = useAuthState();
  const {
    kapItems,
    newEbillingSchedule,
    newEbillingScheduleLoading,
    newEbillingScheduleError,
    ebillingSchedule,
    scheduleLoading,
    scheduleError,
    updateSchedule,
    submitLoading,
    submitError,
    ebillingSchedules,
  } = useEbillingState();

  const [showSuccessModal, setshowSuccessModal] = useState(false);
  const [showErrorModal, setshowErrorModal] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const [kap, setkap] = useState(null);
  const [kjs, setkjs] = useState(null);
  const [total, settotal] = useState("");
  const [npwp, setnpwp] = useState("");
  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [sk, setsk] = useState("");
  const [nop, setnop] = useState("");
  const [taxSubject, settaxSubject] = useState("own");
  const [otherNpwp, setotherNpwp] = useState("");
  const [note, setnote] = useState("");
  const [date, setdate] = useState(null);
  const [month, setmonth] = useState(null);
  const [expired, setexpired] = useState(null);
  const [quotalLeft, setquotalLeft] = useState(0);
  const [createPeriod, setcreatePeriod] = useState(() => {
    const translatedPeriodOptions = periodOptions.map((period) => ({
      value: period?.value,
      label: t(period?.label),
    }));
    return translatedPeriodOptions[0];
  });
  const [ebillingPeriod, setebillingPeriod] = useState(() => {
    const translatedBillingPeriods = billingPeriods.map((period) => ({
      value: period?.value,
      label: t(period?.label),
    }));
    return translatedBillingPeriods[0];
  });
  const [ebillingYear, setebillingYear] = useState(() => {
    const translatedEbillingYear = ebillingYearOptions.map((period) => ({
      value: period?.value,
      label: t(period?.label),
    }));
    return translatedEbillingYear[1];
  });
  const [status, setstatus] = useState(() => {
    const translatedStatus = STATUS.map((status) => ({
      label: t(status.label),
      value: status.value,
    }));
    return translatedStatus[0];
  });

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const parsedSubmitError = submitError?.response?.body
    ? JSON.parse(submitError.response.body)
    : null;

  const parsedEbillingScheduleError = newEbillingScheduleError?.response?.body
    ? JSON.parse(newEbillingScheduleError.response.body)
    : null;

  const errorMessage =
    parsedEbillingScheduleError?.error || parsedSubmitError?.error;

  useEffect(() => {
    if (id) {
      requestGetScheduledEbilling(dispatch, { id });
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (user?.id && !id) {
      requestListScheduledEbilling(dispatch, {
        userID: user.id,
      });
    }
  }, [user?.id, id, dispatch]);

  useEffect(() => {
    const initialQuota = user.membership === "FREE" ? 1 : 10;

    let remainingQuota = initialQuota - ebillingSchedules.length;

    if (remainingQuota < 0) {
      remainingQuota = 0;
    }

    setquotalLeft(remainingQuota);
  }, [ebillingSchedules, user.membership]);

  useEffect(() => {
    if (user.id) {
      requestListKap(dispatch);
    }
  }, [user.id, dispatch]);

  useEffect(() => {
    if (user?.email && !id) {
      setemail(user.email);
    }
  }, [user?.email, id]);

  useEffect(() => {
    return () => {
      resetScheduledEbilling(dispatch);
    };
  }, [dispatch]);

  useEffect(() => {
    if (newEbillingSchedule?.id || updateSchedule?.id) {
      setshowSuccessModal(true);
    }
  }, [newEbillingSchedule?.id, updateSchedule?.id]);

  useEffect(() => {
    if (newEbillingScheduleError || submitError) {
      setshowErrorModal(true);
    }
  }, [newEbillingScheduleError || submitError]);

  useEffect(() => {
    const clearError = (field) => {
      setFormErrors((errors) => ({ ...errors, [field]: undefined }));
    };

    const fields = {
      kap,
      kjs,
      npwp,
      total,
      email,
      createPeriod,
      ebillingPeriod,
      date,
      month,
      ebillingYear,
      expired,
    };

    Object.keys(fields).forEach((field) => {
      if (fields[field]) clearError(field);
    });
  }, [
    kap,
    kjs,
    npwp,
    total,
    email,
    createPeriod,
    ebillingPeriod,
    date,
    month,
    ebillingYear,
    expired,
  ]);

  useEffect(() => {
    if (id && ebillingSchedule?.id) {
      const {
        ebilling,
        createPeriod,
        date,
        ebillingPeriod,
        ebillingYear,
        expiredAt,
        status,
      } = ebillingSchedule;

      const setPeriod = (options, value, setter) => {
        const period = options.find((option) => option.value === value);
        setter({ label: t(period?.label), value: period?.value });
      };

      setPeriod(periodOptions, createPeriod, setcreatePeriod);
      setPeriod(billingPeriods, ebillingPeriod, setebillingPeriod);
      setPeriod(ebillingYearOptions, ebillingYear, setebillingYear);

      setdate({ label: date, value: date });
      if (expiredAt) {
        setexpired(new Date(expiredAt));
      }

      const selectedStatus = STATUS.find((item) => item.value === status);
      setstatus({
        ...selectedStatus,
        label: t(selectedStatus.label),
      });

      if (ebilling) {
        const {
          kapID,
          kjsID,
          summary,
          total,
          note,
          collectorNpwp,
          nop,
          skNumber,
        } = ebilling;
        const selectedKap = kapItems.find((item) => item.value === kapID);
        setkap(selectedKap);

        const selectedKjs = selectedKap?.kjs?.items.find(
          (item) => item.id === kjsID
        );
        if (selectedKjs) {
          setkjs({
            ...selectedKjs,
            label: `${selectedKjs.kjsId} - ${selectedKjs.name}`,
            value: selectedKjs.id,
          });
        }

        setnpwp(summary?.npwp);
        setemail(summary?.email);
        settotal(total);
        setname(summary?.name || "");
        setnote(note || "");
        setotherNpwp(collectorNpwp || "");
        setsk(skNumber || "");
        setnop(nop || "");
      }
    }
  }, [ebillingSchedule?.id, id, kapItems]);

  const getKjsItems = (kap) => {
    if (!kap?.kjs?.items) return [];

    return kap.kjs.items
      .filter((item) => item.period === "MONTHLY")
      .map((item) => ({
        ...item,
        label: `${item.kjsId} - ${item.name}`,
        value: item.id,
      }))
      .sort((a, b) => a.kjsId - b.kjsId);
  };

  const generateDateOptions = (range) => {
    return Array.from({ length: range }, (v, k) => ({
      label: (k + 1).toString(),
      value: (k + 1).toString(),
    }));
  };

  const getMinDate = (monthsAhead = 1) => {
    const date = new Date();
    date.setMonth(date.getMonth() + monthsAhead);
    return date;
  };

  const validateForm = ({
    kap,
    kjs,
    npwp,
    total,
    email,
    createPeriod,
    ebillingPeriod,
    date,
    month,
    ebillingYear,
    status,
    expired,
  }) => {
    const errors = {};

    if (!kap) errors.kap = "Tax account code (KAP) is required.";
    if (!kjs) errors.kjs = "Tax payment code (KJS) is required.";
    if (!npwp || npwp.length < 15 || npwp.length > 16)
      errors.npwp = "Invalid NPWP. Enter 15-16 digits.";
    if (!total) errors.total = "Total is required.";
    if (!sk && kjs?.hasSk) errors.sk = "Notice (SK) number is required.";
    if (!nop && kjs?.hasNop)
      errors.nop = "Tax Object Number (NOP) is required.";
    if (
      (!otherNpwp || otherNpwp.length < 15 || otherNpwp.length > 16) &&
      taxSubject === "other"
    )
      errors.otherNpwp = "Invalid NPWP. Enter 15-16 digits.";
    if (!email || !emailRegex.test(email))
      errors.email = "Please enter a valid email address.";
    if (!createPeriod) errors.createPeriod = "validateCreatePeriodError";
    if (!ebillingPeriod) errors.ebillingPeriod = "validateEbillingPeriodError";
    if (!date) errors.date = "validateDateCreationError";
    if (createPeriod.value === "ANNUALLY" && !month)
      errors.month = "validatemonthCreationError";
    if (!ebillingYear) errors.ebillingYear = "validateEbillingYearError";
    if (!status) errors.status = "validateStatusError";
    if (!expired) errors.expired = "requiredExpiredDate";

    return errors;
  };

  const onCreate = (update = false) => {
    const errors = validateForm({
      kap,
      kjs,
      npwp,
      total,
      email,
      createPeriod,
      ebillingPeriod,
      date,
      month,
      ebillingYear,
      status,
      expired,
    });

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    const ebilling = {
      kapID: kap?.id,
      kjsID: kjs?.id,
      total,
      npwp,
      email,
      name,
    };

    if (note) {
      ebilling.note = note;
    }

    if (sk) {
      ebilling.sk = sk;
    }

    if (nop) {
      ebilling.nop = nop;
    }

    if (otherNpwp) {
      ebilling.collectorNpwp = otherNpwp;
    }

    const input = {
      ebilling,
      createPeriod: createPeriod?.value,
      ebillingPeriod: ebillingPeriod?.value,
      ebillingYear: ebillingYear?.value,
      month: month?.value,
      date: date?.value,
      expiredAt: expired?.toISOString() || null,
      status: status.value,
    };

    if (update) {
      requestUpdateScheduledEbilling(dispatch, {
        input,
        id: ebillingSchedule?.id,
      });
    } else {
      requestCreateScheduledEbilling(dispatch, { input });
    }
  };

  const InputSkeleton = ({ rows }) => {
    const divElements = Array.from({ length: rows }).map((_, index) => (
      <div key={index} className="animate-pulse col-span-4 sm:col-span-2">
        <div className="flex-1 space-y-2">
          <div className="w-36 h-4 bg-gray-300 rounded-md"></div>
          <div className="block h-10 bg-gray-300 rounded-md"></div>
        </div>
      </div>
    ));

    return <>{divElements}</>;
  };

  if (scheduleError) {
    return (
      <div className="bg-white min-h-full rounded-lg p-4">
        <Alert
          type="error"
          title="Error"
          message={scheduleError?.message}
          errors={scheduleError?.errors}
        />
      </div>
    );
  }

  return (
    <div>
      <div className="bg-white border border-gray-200 rounded-md sm:rounded-lg shadow-sm">
        {(newEbillingSchedule?.id || updateSchedule?.id) && (
          <ModalConfirm
            open={showSuccessModal}
            setOpen={(open) => {
              setshowSuccessModal(open);
            }}
            title="Success"
            description={
              updateSchedule?.id
                ? "saveScheduleSuccess"
                : "createScheduleEbillingSuccess"
            }
            type="SUCCESS"
            onConfirm={() => {
              navigate("/scheduled-ebilling");
              resetScheduledEbilling(dispatch);
            }}
          />
        )}
        {(newEbillingScheduleError || submitError) && (
          <ModalConfirm
            open={showErrorModal}
            setOpen={(open) => {
              setshowErrorModal(open);
            }}
            title="Error"
            description={getErrorMessages(
              newEbillingScheduleError || submitError
            )}
            type="ALERT"
            onConfirm={() => {
              setshowErrorModal(false);
            }}
          />
        )}
        <div className="space-y-4 lg:col-span-9 divide-y divide-gray-200">
          {user?.membership && !ebillingSchedule?.id && !id && (
            <div className="pt-4 px-4 sm:px-6">
              <div className="flex flex-col sm:flex-row space-y-2 justify-between sm:items-center">
                {scheduleLoading ? (
                  <div className="animate-pulse">
                    <div className="h-4 w-24 my-1 bg-gray-300 rounded-md"></div>
                    <div className="h-4 w-48 my-1 bg-gray-300 rounded-md"></div>
                  </div>
                ) : (
                  <div>
                    <Badge
                      title={`${user.membership} MEMBER`}
                      type={membershipType[user.membership] || "alert"}
                    />
                    <p className="font-medium text-gray-900 mt-1">
                      {quotalLeft} {t("quotaScheduleTitle")}
                    </p>
                  </div>
                )}
                {user.membership === "FREE" && (
                  <Button
                    onClick={() => navigate("/subscription")}
                    outline
                    title="Become Premium Member"
                  />
                )}
              </div>
            </div>
          )}

          <div className="grid grid-cols-4 gap-6  py-4 px-4 sm:px-6">
            {scheduleLoading ? (
              <InputSkeleton rows={7} />
            ) : (
              <>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel
                    htmlFor="kap"
                    label={t("Tax Account Code (KAP)")}
                    required
                  />
                  <Select
                    name="kap"
                    id="kap"
                    className="mt-1 text-sm"
                    classNamePrefix="select2-selection"
                    options={kapItems}
                    placeholder={t("Select Tax Account Code (KAP)")}
                    value={kap}
                    onChange={setkap}
                  />
                  {(formErrors?.kap || errorMessage?.ebilling?.kapID) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(formErrors.kap || errorMessage.ebilling.kapID)}
                    </div>
                  )}
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel
                    htmlFor="kjs"
                    label={t("Tax Payment Code (KJS)")}
                    required
                  />
                  <Select
                    name="kjs"
                    id="kjs"
                    className="mt-1 text-sm"
                    classNamePrefix="select2-selection"
                    options={getKjsItems(kap)}
                    isDisabled={!kap?.id}
                    placeholder={
                      !kap?.id
                        ? t("Please select KAP first")
                        : t("Select Tax Payment Code (KJS)")
                    }
                    value={kjs}
                    onChange={setkjs}
                  />
                  {(formErrors?.kjs || errorMessage?.ebilling?.kjsID) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(formErrors.kjs || errorMessage.ebilling.kjsID)}
                    </div>
                  )}
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel
                    htmlFor="npwp"
                    label={t("Tax Identification Number (NPWP)")}
                    required
                  />
                  <NumericFormat
                    type="text"
                    name="npwp"
                    id="npwp"
                    allowLeadingZeros
                    className="mt-1 py-2 px-3 ebilling-input text-sm"
                    placeholder={t(
                      "Enter the tax identification number (NPWP)"
                    )}
                    displayType="input"
                    value={npwp}
                    onValueChange={(value) => {
                      setnpwp(value.value);
                    }}
                    isAllowed={({ value }) => value.length <= 16}
                  />
                  {(formErrors?.npwp || errorMessage?.ebilling?.npwp?.[0]) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(formErrors.npwp || errorMessage.ebilling.npwp[0])}
                    </div>
                  )}
                </div>
                {/* SK */}
                {kjs?.hasSk && (
                  <div className="col-span-4 sm:col-span-2">
                    <FormLabel
                      htmlFor="sk"
                      label={t("Notice (SK) Number")}
                      required
                    />
                    <PatternFormat
                      type="text"
                      name="sk"
                      id="sk"
                      className="mt-1 py-2 px-3 ebilling-input text-sm"
                      placeholder={t("Enter notice (SK) number")}
                      format="#####/###/##/###/##"
                      mask="_"
                      value={sk}
                      onValueChange={(value) => {
                        setsk(value.value);
                      }}
                    />
                    {formErrors?.sk && (
                      <div className="text-red-500 text-sm mt-1">
                        {t(formErrors.sk)}
                      </div>
                    )}
                  </div>
                )}

                {/* Tax Object */}
                {kjs?.hasNop && (
                  <div className="col-span-4 sm:col-span-2">
                    <FormLabel
                      htmlFor="nop"
                      label={t("Tax Object Number (NOP)")}
                      required
                    />
                    <PatternFormat
                      type="text"
                      name="nop"
                      id="nop"
                      className="mt-1 py-2 px-3 ebilling-input text-sm"
                      placeholder={t("Enter the tax object number (NOP)")}
                      format="##.##.###.###.###.####.#"
                      mask="_"
                      value={nop}
                      onValueChange={(value) => {
                        setnop(value.value);
                      }}
                    />
                    {formErrors?.nop && (
                      <div className="text-red-500 text-sm mt-1">
                        {t(formErrors.nop)}
                      </div>
                    )}
                  </div>
                )}

                {/* Subjek Pajak */}
                {kjs?.hasOtherNpwp && (
                  <div className="col-span-4 sm:col-span-2">
                    <label
                      htmlFor="tax-subject"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {t("Tax Subject")}
                    </label>
                    <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10 mt-1 py-2">
                      <div className="flex items-center">
                        <input
                          id="own"
                          name="tax-subject"
                          type="radio"
                          value="own"
                          checked={taxSubject === "own"}
                          onChange={(e) => settaxSubject(e.target.value)}
                          className="text-sm focus:outline-none focus:ring-0 focus:ring-offset-0 h-4 w-4 text-blue-600 border-gray-300"
                        />
                        <label
                          htmlFor="own"
                          className="ml-3 block text-sm font-medium text-gray-700"
                        >
                          {t("Own NPWP")}
                        </label>
                      </div>
                      <div className="flex items-center">
                        <input
                          id="other"
                          name="tax-subject"
                          type="radio"
                          value={"other"}
                          checked={taxSubject === "other"}
                          onChange={(e) => settaxSubject(e.target.value)}
                          className="text-sm focus:outline-none focus:ring-0 focus:ring-offset-0 h-4 w-4 text-blue-600 border-gray-300"
                        />
                        <label
                          htmlFor="other"
                          className="ml-3 block text-sm font-medium text-gray-700"
                        >
                          {t("Other NPWP")}
                        </label>
                      </div>
                    </div>
                  </div>
                )}

                {/* NPWP Lain Input */}
                {kjs?.hasOtherNpwp && taxSubject === "other" && (
                  <div className="col-span-4 sm:col-span-2">
                    <FormLabel
                      htmlFor="other-npwp"
                      label={t("Other NPWP")}
                      required
                    />
                    <NumericFormat
                      type="text"
                      name="other-npwp"
                      id="other-npwp"
                      allowLeadingZeros
                      className="mt-1 py-2 px-3 ebilling-input text-sm"
                      placeholder={t("Enter the other NPWP")}
                      displayType="input"
                      value={otherNpwp}
                      onValueChange={(e) => setotherNpwp(e.target.value)}
                      isAllowed={({ value }) => value.length <= 16}
                    />
                    {formErrors?.otherNpwp && (
                      <div className="text-red-500 text-sm mt-1">
                        {t(formErrors.otherNpwp)}
                      </div>
                    )}
                  </div>
                )}
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel
                    htmlFor="total"
                    label={t("Total Payment")}
                    required
                  />
                  <NumericFormat
                    type="text"
                    name="total"
                    id="total"
                    className="mt-1 py-2 px-3 ebilling-input text-sm"
                    placeholder={t("Enter total payment")}
                    thousandSeparator="."
                    decimalSeparator=","
                    displayType="input"
                    prefix={"Rp"}
                    value={total}
                    onValueChange={(value) => {
                      settotal(value.value);
                    }}
                  />
                  {(formErrors?.total ||
                    errorMessage?.ebilling?.total?.[0]) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(formErrors.total || errorMessage.ebilling.total[0])}
                    </div>
                  )}
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel htmlFor="name" label={t("Name")} />
                  <input
                    type="text"
                    name="name"
                    id="name"
                    className="mt-1 py-2 px-3 ebilling-input text-sm"
                    placeholder={t("Enter name of the NPWP owner")}
                    value={name}
                    onChange={(e) => setname(e.target.value)}
                  />
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel htmlFor="note" label={t("Note")} />
                  <input
                    type="text"
                    name="note"
                    id="note"
                    className="mt-1 py-2 px-3 ebilling-input text-sm"
                    placeholder={t("Enter note")}
                    value={note}
                    onChange={(e) => setnote(e.target.value)}
                  />
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel htmlFor="email" label={t("Email")} required />
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="mt-1 py-2 px-3 ebilling-input text-sm"
                    placeholder={t("Enter email to receive payment receipt")}
                    value={email}
                    onChange={(e) => setemail(e.target.value)}
                  />
                  {(formErrors?.email ||
                    errorMessage?.ebilling?.email?.[0]) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(formErrors.email || errorMessage.ebilling.email[0])}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="grid grid-cols-4 gap-6  py-4 px-4 sm:px-6">
            {scheduleLoading ? (
              <InputSkeleton rows={6} />
            ) : (
              <>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel htmlFor="status" label={t("Status")} required />
                  <Select
                    name="status"
                    id="status"
                    options={STATUS.map((item) => ({
                      value: item.value,
                      label: t(item.label),
                    }))}
                    value={status}
                    onChange={setstatus}
                    className="mt-1 text-sm"
                    classNamePrefix="select2-selection"
                    placeholder={t("statusPlaceholder")}
                  />
                  {(formErrors?.status || errorMessage?.status) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(formErrors.status || errorMessage.status)}
                    </div>
                  )}
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel
                    htmlFor="createPeriod"
                    label={t("createPeriod")}
                    required
                  />
                  <Select
                    name="createPeriod"
                    id="createPeriod"
                    options={periodOptions.map((period) => ({
                      value: period.value,
                      label:
                        period.value === "ANNUALLY"
                          ? `${t(period.label)} (${t("notSupportedYet")})`
                          : t(period.label),
                      isDisabled: period.value === "ANNUALLY",
                    }))}
                    value={createPeriod}
                    onChange={setcreatePeriod}
                    className="mt-1 text-sm"
                    classNamePrefix="select2-selection"
                    placeholder={t("createPeriodPlaceholder")}
                  />
                  {(formErrors?.createPeriod ||
                    errorMessage?.createPeriod?.[0]) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(
                        formErrors.createPeriod || errorMessage.createPeriod[0]
                      )}
                    </div>
                  )}
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel
                    htmlFor="ebillingPeriod"
                    label={t("ebillingPeriod")}
                    required
                  />
                  <Select
                    name="ebillingPeriod"
                    id="ebillingPeriod"
                    options={billingPeriods.map((period) => ({
                      value: period.value,
                      label: t(period.label),
                    }))}
                    value={ebillingPeriod}
                    onChange={setebillingPeriod}
                    className="mt-1 text-sm"
                    classNamePrefix="select2-selection"
                    placeholder={t("ebillingPeriodPlaceholder")}
                  />
                  {(formErrors?.ebillingPeriod ||
                    errorMessage?.ebillingPeriod?.[0]) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(
                        formErrors.ebillingPeriod ||
                          errorMessage.ebillingPeriod[0]
                      )}
                    </div>
                  )}
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel
                    htmlFor="date"
                    label={t("dateCreation")}
                    required
                  />
                  <Select
                    name="date"
                    id="date"
                    options={generateDateOptions(28)}
                    value={date}
                    onChange={setdate}
                    className="mt-1 text-sm"
                    classNamePrefix="select2-selection"
                    placeholder={t("dateCreationPlaceholder")}
                  />
                  {(formErrors?.date || errorMessage?.date?.[0]) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(formErrors.date || errorMessage.date[0])}
                    </div>
                  )}
                </div>
                {createPeriod.value === "ANNUALLY" && (
                  <div className="col-span-4 sm:col-span-2">
                    <FormLabel
                      htmlFor="month"
                      label={t("monthCreation")}
                      required
                    />
                    <Select
                      name="month"
                      id="month"
                      options={months.map((month) => ({
                        value: month.value,
                        label: t(month.label),
                      }))}
                      value={month}
                      onChange={setmonth}
                      className="mt-1 text-sm"
                      classNamePrefix="select2-selection"
                      placeholder={t("monthCreationPlaceholder")}
                    />
                    {(formErrors?.month || errorMessage?.month?.[0]) && (
                      <div className="text-red-500 text-sm mt-1">
                        {t(formErrors.month || errorMessage.month[0])}
                      </div>
                    )}
                  </div>
                )}
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel
                    htmlFor="ebillingYear"
                    label={t("ebillingYear")}
                    required
                  />
                  <Select
                    name="ebillingYear"
                    className="mt-1 text-sm"
                    classNamePrefix="select2-selection"
                    options={ebillingYearOptions.map((ebillingYearOption) => ({
                      value: ebillingYearOption?.value,
                      label: t(ebillingYearOption?.label),
                    }))}
                    placeholder={t("ebillingYearPlaceholder")}
                    value={ebillingYear}
                    onChange={setebillingYear}
                  />
                  {(formErrors?.ebillingYear ||
                    errorMessage?.ebillingYear?.[0]) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(
                        formErrors.ebillingYear || errorMessage.ebillingYear[0]
                      )}
                    </div>
                  )}
                </div>
                <div className="col-span-4 sm:col-span-2">
                  <FormLabel htmlFor="expired" label={t("Expired")} required />
                  <ReactDatePicker
                    name="data"
                    className="mt-1 block w-full text-sm rounded-md shadow-sm border-gray-300 focus:border-blue-500 focus:ring-blue-500"
                    selected={expired}
                    onChange={setexpired}
                    placeholderText={t("Select Date")}
                    dateFormat="dd/MM/yyyy"
                    minDate={getMinDate(1)}
                  />
                  {(formErrors?.expired || errorMessage?.expired?.[0]) && (
                    <div className="text-red-500 text-sm mt-1">
                      {t(formErrors.expired || errorMessage.expired[0])}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="bg-gray-50 rounded-b-md sm:rounded-b-lg px-4 py-6 text-right sm:px-6">
          <Button
            disabled={
              (quotalLeft <= 0 && !ebillingSchedule?.id && !id) ||
              newEbillingScheduleLoading ||
              scheduleLoading ||
              submitLoading
            }
            loading={
              newEbillingScheduleLoading || scheduleLoading || submitLoading
            }
            onClick={() => {
              ebillingSchedule?.id ? onCreate(true) : onCreate();
            }}
            className="w-full sm:w-auto"
            title={t(id ? "Save" : "createScheduleTitle")}
          />
        </div>
      </div>
    </div>
  );
};

export default EbillingScheduleCreate;
